import { RootState } from '../../../../app/store'

export default function getReduxState(state: RootState) {
  return { state, collections: state.collections }
}
